/*********************************************************
 * Copyright (C) 2014-2020 VMware, Inc. All rights reserved.
 *********************************************************/

import { CLIENT } from '@html-core';

export class BaseViewClientModel {
   public vendor: string = "Omnissa";
   // Architecture of client
   public arch:string = 'browser';
   public product:string = '';
      // Product version
      public version: string = CLIENT.clientVersion;
   // unique client ID
   public clientID: string = '';
   public linkModel = {
      // Help Pages, now Unique ID
      helpPages: {},
      /**
       * EULAs of Chrome Client and HTML Access
       * We do not support localized EULA & patent pages for locales.
       * Use the English EULA landing page for now.
       */
      'eulaPages': {
         'en': BaseViewClientModel.generateEULA('en'),
         'de': BaseViewClientModel.generateEULA('de'),
         'es': BaseViewClientModel.generateEULA('es'),
         'fr': BaseViewClientModel.generateEULA('fr'),
         'ja': BaseViewClientModel.generateEULA('ja'),
         'ko': BaseViewClientModel.generateEULA('ko'),
         'zh-CN': BaseViewClientModel.generateEULA('zh-cn'),
         'zh-TW': BaseViewClientModel.generateEULA('zh-tw'),
      },
      patentPages: {
         en: BaseViewClientModel.generatePatent("en"),
         de: BaseViewClientModel.generatePatent("de"),
         es: BaseViewClientModel.generatePatent("es"),
         fr: BaseViewClientModel.generatePatent("fr"),
         ja: BaseViewClientModel.generatePatent("jp"),
         ko: BaseViewClientModel.generatePatent("kr"),
         "zh-CN": BaseViewClientModel.generatePatent("cn"),
         "zh-TW": BaseViewClientModel.generatePatent("tw")
      }
   };

   public MIN_VERSION = {
      'IE': 10,
      'Firefox': 36,
      'Gecko': 21,
      'Chrome': 41,
      'Safari': 7,
      'WebKit': 536
   };

   public acceptLanguage = null;
   public clientVersion = null;
   public logLevel = null;
   public ipAddress = null;
   public rebrandName = null;
   public rebrandEnable: boolean = false;
   public rebrandHelpUrl = '';
   public rebrandGotoForumUrl = '';
   public windowsTimezone = null;

   /**
    *  Features in 'client-config' of broker response
    *  They're updated in 'session-data.service.ts' now.
    */
   public clientHideDomainList = false;
   public clientHideServerInformation = false;
   public enableCredentialCleanupForHTMLAccess = false;

   constructor(isChrome: boolean) {
      if (isChrome) {
         this.product = "Omnissa Horizon Client for Chrome";
         this.linkModel["helpPages"] = {
            en: BaseViewClientModel.generateChromeClientHelpLink("en-US"),
            de: BaseViewClientModel.generateChromeClientHelpLink("de-DE"),
            es: BaseViewClientModel.generateChromeClientHelpLink("es-ES"),
            fr: BaseViewClientModel.generateChromeClientHelpLink("fr-FR"),
            ja: BaseViewClientModel.generateChromeClientHelpLink("ja-JP"),
            ko: BaseViewClientModel.generateChromeClientHelpLink("ko-KR"),
            "zh-CN": BaseViewClientModel.generateChromeClientHelpLink("zh-CN"),
            "zh-TW": BaseViewClientModel.generateChromeClientHelpLink("zh-TW")
         };
      } else {
         this.product = "Omnissa Horizon Web Client";
         this.linkModel["helpPages"] = {
            en: BaseViewClientModel.generateHtmlAccessHelpLink("en-US"),
            de: BaseViewClientModel.generateHtmlAccessHelpLink("de-DE"),
            es: BaseViewClientModel.generateHtmlAccessHelpLink("es-ES"),
            fr: BaseViewClientModel.generateHtmlAccessHelpLink("fr-FR"),
            ja: BaseViewClientModel.generateHtmlAccessHelpLink("ja-JP"),
            ko: BaseViewClientModel.generateHtmlAccessHelpLink("ko-KR"),
            "zh-CN": BaseViewClientModel.generateHtmlAccessHelpLink("zh-CN"),
            "zh-TW": BaseViewClientModel.generateHtmlAccessHelpLink("zh-TW")
         };
      }
   }

   public static generateEULA = (local) => {
      return "https://www.omnissa.com/general-terms/";
   };

   public static generateHtmlAccessHelpLink = (local) => {
      return (
         "https://docs.omnissa.com/" +
         local +
         "/bundle/HorizonHTMLAccessGuideV" +
         this._generateMajorVersion() +
         "/" +
         "page/HorizonHTMLAccessGuide.html"
      );
   };

   public static generateChromeClientHelpLink = (local) => {
      return (
         "https://docs.omnissa.com/" +
         local +
         "/bundle/HorizonClient-ChromeGuideV" +
         this._generateMajorVersion() +
         "/page/VMwareHorizonClientforChromeGuide.html"
      );
   };

   public static generatePatent = (local) => {
      return "https://static.omnissa.com/uploads/patent-marking-public-website.pdf";
   };

   private static _generateMajorVersion = () => {
      //When there is a minor version, only return major version
      let versionArray = CLIENT.marketVersion.split(".");
      return versionArray[0];
   }
}